// extracted by mini-css-extract-plugin
module.exports = {"navbarfontclass":"Home_navbarfontclass__2CfQa","hometaglinetypography":"Home_hometaglinetypography__3EIxa","homebuttontypography":"Home_homebuttontypography__34b3S"};